import { useCallback, useMemo, useState } from 'react';
import { useDialog, UseDialogResult } from '../../../../hooks/useDialog';

type UseConfirmDeletionDialogResult = Omit<UseDialogResult, 'openDialog'> & {
    openDialog: (args: { itemId: string; itemName: string }) => void;
    itemId: string | undefined;
    message: string;
};

export const useConfirmDeletionDialog = (
    messageFactory: (itemName: string) => string
): UseConfirmDeletionDialogResult => {
    const dialogCore = useDialog();
    const { openDialog: openDialogCore, closeDialog: closeDialogCore } =
        dialogCore;

    const [itemId, setItemId] = useState<string | undefined>(undefined);
    const [itemName, setItemName] = useState<string | undefined>(undefined);

    const openDialog = useCallback<
        UseConfirmDeletionDialogResult['openDialog']
    >(
        ({ itemId, itemName }) => {
            setItemId(itemId);
            setItemName(itemName);

            openDialogCore();
        },
        [openDialogCore]
    );

    const closeDialog = useCallback(() => {
        closeDialogCore();

        setItemId(undefined);
        setItemName(undefined);
    }, [closeDialogCore]);

    const message = useMemo(() => {
        if (itemName) {
            return messageFactory(itemName);
        }

        return '';
    }, [itemName, messageFactory]);

    return {
        ...dialogCore,
        message,
        openDialog,
        closeDialog,
        itemId,
    };
};
